import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontAngkor, fontFredoka, theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import QuizFlag from "scmp-app/components/content/content-item-render/variants/posties-primary/quiz-flag.svg";
import { EntityLink } from "scmp-app/components/entity-link";
import { Button } from "scmp-app/components/posties/button";
import { OffsetContainer } from "scmp-app/components/posties/offset-container";

import BlueBook from "./blue-book.svg?url";
import Flag from "./flag.svg?url";
import LightBlueBook from "./light-blue-book.svg?url";
import MobileFlag from "./mobile-flag.svg?url";
export const StyledButton = styled(Button)``;

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 20px;

  overflow: hidden;
`;

export const FlagContainer = styled.div`
  position: absolute;
  inset-block-start: -10px;
  inset-inline-end: 17px;
  z-index: 1;

  ${theme.breakpoints.up("tablet")} {
    inset-block-start: -15px;
    inset-inline-end: 22.89px;
  }
  ${theme.breakpoints.up("desktop")} {
    inset-block-start: -18px;
    inset-inline-end: 67.72px;
  }
`;

export const StyledFlag = styled.div`
  inline-size: 65.3px;
  block-size: 64.2px;

  background-image: url(${MobileFlag});
  background-repeat: no-repeat;
  background-size: contain;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 98.66px;
    block-size: 97px;

    background-image: url(${Flag});
  }
  ${theme.breakpoints.up("desktop")} {
    inline-size: 119px;
    block-size: 117px;
  }
`;

export const FlagText = styled.div`
  position: absolute;
  inset-block-start: 42%;
  inset-inline-start: 57%;

  inline-size: 81%;

  color: #ffffff;
  font-size: 12px;
  font-family: ${fontAngkor};
  letter-spacing: -0.02em;
  text-align: center;
  text-transform: uppercase;

  transform: translate(-50%, -50%);

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
  ${theme.breakpoints.up("desktop")} {
    font-size: 24px;
  }

  span {
    display: block;

    font-size: 24px;
    line-height: 22px;
    ${theme.breakpoints.up("tablet")} {
      font-size: 40px;
      line-height: 33px;
    }
    ${theme.breakpoints.up("desktop")} {
      font-size: 48px;
      line-height: 40px;
    }
  }
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  margin-inline-start: 10px;
  aspect-ratio: 3/2;
  ${theme.breakpoints.up("largeDesktop")} {
    aspect-ratio: 16/9;
  }

  ${Figure} {
    position: relative;
    inset-block-start: 8px;
    inset-inline-end: 8px;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 20px;

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: 9px;
      inset-inline-end: 9px;
    }
    ${theme.breakpoints.up("desktop")} {
      inset-block-start: 10px;
      inset-inline-end: 10px;
    }
  }
`;

export const Headline = styled.div`
  margin-block-end: 16px;

  color: #1b4191;
  ${ContentHeadline}, ${SponsorHeadline} {
    inline-size: 100%;

    font-weight: 400;
    font-size: 24px;
    font-family: ${fontAngkor};
    line-height: 28px;
    letter-spacing: -0.72px;
    text-align: center;
    ${theme.breakpoints.up("tablet")} {
      margin-block: 41px 20px;

      font-size: 32px;
      line-height: 38px;
      letter-spacing: -0.96px;
    }
    ${theme.breakpoints.up("desktop")} {
      margin-block-start: 42px;
    }
  }
`;

export const StyledEntityLink = styled(EntityLink)``;

export const Content = styled.div`
  position: relative;
  z-index: 1;

  margin-block-start: 24px;
  margin-inline: auto;
  padding-inline: 24px;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 640px;
    margin-block-start: 40px;
    padding-inline: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 822px;
  }
`;

export const Container = styled.div``;

export const Section = styled(BaseLink)`
  inline-size: fit-content;
  margin-block-end: 16px;
  margin-inline: auto;
  padding-block: 4.13px;
  padding-inline: 8.26px;

  color: #ffffff;
  font-weight: 600;
  font-size: 9.3px;
  font-family: ${fontFredoka};
  line-height: 12.4px;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;

  border-radius: 4.13px;

  background: #ff7c1d;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 12px;
    padding-block: 8px;
    padding-inline: 16px;

    font-size: 18px;
    line-height: 24px;

    border-radius: 8px;
  }
`;

export const StyledImageEntityLink = styled(EntityLink)`
  position: relative;
  z-index: 1;

  display: grid;
  grid:
    "image" min-content
    / 100%;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  margin-inline: auto;
  padding-inline: 24px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 641.09px;
    padding-inline: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    inline-size: 845.22px;
    margin-inline: auto;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: 942px;
    aspect-ratio: 16/9;

    &::before {
      position: absolute;
      inset-block-start: -92px;
      inset-inline-start: -219px;
      content: "";

      inline-size: 365px;
      block-size: 305px;

      background: url(${LightBlueBook});
    }

    &::after {
      position: absolute;
      inset-block-end: -136px;
      inset-inline-end: -197px;
      content: "";

      inline-size: 314.5px;
      block-size: 273.61px;

      background: url(${BlueBook});
    }
  }

  ${StyledOffsetContainer} {
    grid-area: image;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;

  display: block;
`;

export const StyledQuizFlag = styled(QuizFlag)`
  position: absolute;
  inset-block-end: 18px;
  inset-inline-start: -22px;
  z-index: 1;

  inline-size: 108px;
  block-size: 38px;

  ${theme.breakpoints.up("tablet")} {
    inset-block-end: 48px;
    inset-inline-start: -30px;

    inline-size: 162px;
    block-size: 57px;
  }

  ${theme.breakpoints.up("desktop")} {
    inset-inline-start: -32px;

    inline-size: 219px;
    block-size: 82px;
  }
`;
